/**
 * Extra controls rendered under a stored assistant answer (from
 * `message.id`), in the style of `views/registry.ts`. A package (P2–P5)
 * appends one entry by creating its footer component and adding it here:
 * one import, one entry.
 */
import type { FC } from "react";
import { AgentFeedback } from "../AgentFeedback.js";

export type AgentMessageFooterProps = {
  messageId: string;
  conversationId: string | null;
};

export type AgentMessageFooterComponent = FC<AgentMessageFooterProps>;

export const agentMessageFooters: AgentMessageFooterComponent[] = [
  AgentFeedback,
];
